import React, { useRef,useEffect,useState } from 'react'
import AppConfig from './Config.js';
import { useSpring, animated,useTrail }  from '@react-spring/web';
import { Howl, Howler } from 'howler';
import ReactHowler from 'react-howler';
import {useNavigate ,useLocation,useSearchParams} from 'react-router-dom';
import { useGesture , useDrag} from '@use-gesture/react';
import './style.css';
import { useStore } from './store'
const hostloca=AppConfig.cdnUrl;


let tempy=0

let mov=0
let canmove=true
let intapidata=false


function Introa(props){

    const [movey,setmovey]=useState(0)
    const [actmove,setactmove]=useState(false)

  

    let imgradio=2200/1080
    let bgitemtop=(window.innerHeight-(window.innerWidth*imgradio))/2
    

    let w=window.innerWidth
    let h=window.innerHeight

    let imgw=w
    let imgh=imgw*imgradio

    const size = Math.sqrt(w * w + h * h)*1.3;  

    let degrees = 45;
    let radians = degrees * Math.PI / 180;  // 将角度转换为弧度

    let sinValue = Math.sin(radians);       // 计算正弦值
    let cosValue = Math.cos(radians); 



    let movex= -w/2
 
    


    
    const sizea = Math.sqrt(w * w + h * h)/10; // 计算对角线长度
    const topOffset = (size - h) / 2; // 计算顶部偏移
    const leftOffset = (size - w) / 2; // 计算左侧偏移
    const atop = (h - size) / 2+movey; // 计算左侧偏移
    const aleft = (w - size) / 2+movex; // 计算左侧偏移




    let  gl_my= movey*sinValue
    let  gl_mx= movey*cosValue



    const ctop =(size-imgh)/2 - imgw/2*sinValue - gl_my; //  
    const cleft = (size-imgw)/2+imgw/2/sinValue/2 -gl_mx; // 计算左侧偏移


    useEffect(()=>{

       if(props.act){



        setactmove(true)
        mov=movey
       }else{

        if(props.introstate==1 && props.pointery>0){

            setmovey(-props.pointery*2)
    
           }

       }
      
      
    },[props])


    useEffect(() => {
        // 创建一个间隔定时器
        const timerId = setInterval(() => {
          //  console.log('This message logs every 2 seconds');

          if(actmove && movey>-1000){
          mov -=10
          setmovey(mov)
         // setmovey(mov)
         // console.log(mov)
         }
           
        }, 10);

        // 返回一个清理函数，在组件卸载时调用
        return () => {
            clearInterval(timerId);
            console.log('Interval cleared');  // 确认定时器已被清除
        };
    }, []); // 空依赖数组确保effect只在组件挂载时执行一次



    return  <div  style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center'}}>

                    <div  style={{
                        width: size + 'px',
                        height: size + 'px',
                        position: 'absolute',
                        left: aleft,
                        top: atop,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        transform: 'rotate(45deg)',
                        transformOrigin: 'center',
                        
                    }}
                    >
                    <img 
                        src={`${hostloca}Assets/intro1.jpg`} 
                        style={{
                        width:imgw , // Set image width to screen width
                        position: 'absolute',
                        top: ctop, // Adjust this to position correctly
                        left: cleft, // Center the image horizontally
                        transform: 'rotate(-45deg)', // Counter rotate the image
                        transformOrigin: 'center',
                        }}
                    />
                    </div>
            </div>


}



function Introb(props){

    let imgradio=2200/1080
    let bgitemtop=(window.innerHeight-(window.innerWidth*imgradio))/2
    

    let w=window.innerWidth
    let h=window.innerHeight

    let imgw=w
    let imgh=imgw*imgradio

    const size = Math.sqrt(w * w + h * h)*1.3;  

    let degrees = 45;
    let radians = degrees * Math.PI / 180;  // 将角度转换为弧度

    let sinValue = Math.sin(radians);       // 计算正弦值
    let cosValue = Math.cos(radians); 



    let movex= -w/2
    let movey=0    //move

    


    
    const sizea = Math.sqrt(w * w + h * h)/10; // 计算对角线长度
    const topOffset = (size - h) / 2; // 计算顶部偏移
    const leftOffset = (size - w) / 2; // 计算左侧偏移
    const atop = (h - size) / 2+movey; // 计算左侧偏移
    const aleft = (w - size) / 2+movex; // 计算左侧偏移




    let  gl_my= movey*sinValue
    let  gl_mx= movey*cosValue



    const ctop =(size-imgh)/2 - imgw/2*sinValue - gl_my; //  
    const cleft = (size-imgw)/2+imgw/2/sinValue/2 -gl_mx; // 计算左侧偏移



    return  <div  style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center'}}>

                    <div  style={{
                        width: size + 'px',
                        height: size + 'px',
                        position: 'absolute',
                        left: aleft,
                        top: atop,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        transform: 'rotate(45deg)',
                        transformOrigin: 'center',
                        
                    }}
                    >
                    <img 
                        src={`${hostloca}Assets/intro2.jpg`} 
                        style={{
                        width:imgw , // Set image width to screen width
                        position: 'absolute',
                        top: ctop, // Adjust this to position correctly
                        left: cleft, // Center the image horizontally
                        transform: 'rotate(-45deg)', // Counter rotate the image
                        transformOrigin: 'center',
                        }}
                    />
                    </div>
            </div>


}

export default function Home(props) {

     
    const [bgtop,setbgtop]=useState(0)
    const [active,setactive]=useState(false)
    const [introstate,setintrostate]=useState(1)
    const [toggle, setToggle] =useState(true);

    const [btnalpha,setbtnalpha]=useState(1)
    const [btn1alpha,setbtn1alpha]=useState(1)

    
     let w=window.innerWidth
     let h=window.innerHeight

    const [Intro1top,setIntro1top]=useState(0)
    const [Intro2top,setIntro2top]=useState(window.innerHeight)
    const [Intro3top,setIntro3top]=useState(window.innerHeight)

    const [Intromovespeed,setIntromovespeed]=useState([1,1,1])

    const imgradio=2200/1080
    const imgh=window.innerWidth*imgradio
    const bgitemtop=(window.innerHeight-(window.innerWidth*imgradio))/2

    const [videopose,setvideopose]=useState(['100vw','100vh',0,0])

    const [arrowalpha,setarrowalpha]=useState(1)
    const [showpagealpha,setshowpagealpha]=useState(0)
    const hvideoEl = useRef(null);
    const hvideoE2 = useRef(null);
    const hvideoE3 = useRef(null);

    
    const [videoplaying,setvideoplaying]=useState(false)



    const audioRef = useRef(null);  // 创建ref来引用audio元素
    const [isPlaying, setIsPlaying] = useState(false);  // 管理播放状态

    const [searchParams] = useSearchParams();
    
    let navigate =useNavigate();
    let location =useLocation()

    const state = useStore()




    useEffect(()=>{

        console.log(state.count+'test storm')

         //posemessage=================================================

 

         let posemsg={code:'8888',nickname:'yy'}
         window.Wxminiposemessage(posemsg)
 

         //===================================================


      


         if(intapidata==false){
            intapidata=true
            console.log('init api')

         
            const getstate = searchParams.get('state');  
            const getcode = searchParams.get('code'); // "param" 是你想获取的查询参数的键

                //No message code 
                if(getstate=='Nomsgcode' || getstate==null || getstate==''){



                }else{
                    //Direct to card page

                    console.log('get message code :'+getstate)

                

                }

                //No WX code 
                if(getcode=='' || getcode==null ){


                }else{


                 //   fetchData('https://www.irabit.com/wxapi/authologin_api.php?code='+getcode);

                }


                const storedName = localStorage.getItem('mm_user_nick');
                if (storedName) {
                    console.log('User : '+storedName)
                   // alert(storedName)
                }else{
                  //  alert('creat user')
                    localStorage.setItem('mm_user_nick', 'Yi');
                }


                const storeopenid = localStorage.getItem('mm_user_opd');
                if (storeopenid) {
                    console.log('openid : '+storeopenid)
                   // alert(storeopenid)
                }else{
                    
                    localStorage.setItem('mm_user_opd', '123123123');
                }


 


         }




     },[])



             
     function fetchData(geturl) {
        fetch(geturl)  // 替换为你的API端点
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);

                }
                return response.json();
            })
            .then(data => {
            
             //  let gotourl='https://www.irabit.com/oid=?'+data.openid+'&nick='+data.nickname

              console.log(data)
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
                
            });
      }






    useEffect(()=>{

       
  
        let videoradio=664/320
        let h=window.innerHeight
        let videow=window.innerWidth
        let videoh=window.innerWidth*videoradio
        let videotop=0
        let videoleft=0
  
        if(videoh>h){
  
          videotop=(h-videoh)/2
  
        }else{
          videoh=h
          videotop=0
  
          videow=videoh*320/664
  
          videoleft=(window.innerWidth-videow)/2
  
        }
   
        setvideopose([videow,videoh,videoleft,videotop])
   
            attemptPlay();
            attemptPlay2();
             attemptPlay3()

             setTimeout(() => {
                 setshowpagealpha(1)
           }, 300);
            
  
            
            // 获取video元素
            const hvideoElement = hvideoEl.current;
        
            // 定义事件处理函数
            const handlePlay = () => {
               
                console.log('Video is now playing');
                setvideoplaying(true)
            };

            

            // 添加事件监听器
            hvideoElement.addEventListener('play', handlePlay);


            /*
            window.addEventListener('WeixinJSBridgeReady',()=>{
                console.log('wwwwxxxx')

            }, false);
            */

            // 组件卸载时移除事件监听器
            return () => {
                hvideoElement.removeEventListener('play', handlePlay);
            };
            



           
          },[])

        

 

          
  
          const attemptPlay = () => {
            hvideoEl &&
              hvideoEl.current &&
              hvideoEl.current.play().catch(error => {
                console.error("Error attempting to play", error);
              });
           };

           const attemptPlay2 = () => {
            hvideoE2 &&
            hvideoE2.current &&
            hvideoE2.current.play().catch(error => {
                console.error("Error attempting to play", error);
              });
           };

           
           const attemptPlay3 = () => {
            hvideoE3 &&
            hvideoE3.current &&
            hvideoE3.current.play().catch(error => {
                console.error("Error attempting to play", error);
              });
           };


    const collectprops = useSpring({
        to: { transform: `scale(${toggle ? 1.5 : 1})` },
        from: { transform: 'scale(1)' },
        reset: true,
        reverse: toggle,
        delay:0,
        onRest: () => {
            setToggle(!toggle)
        },
      });

 
 


      const bindqatwodrag = useGesture({
        onDragStart: ({down,movement: [mx,my] }) => {
        
          if(down){
           //   console.log('drag in'+my)
               tempy=my

               if(videoplaying==false){
                setvideoplaying(true)
               attemptPlay();
               attemptPlay2()
               attemptPlay3()
               }
           }
      },
  
      onDrag: ({ down, movement: [mx,my] }) => {
          
        if (!down) {
  
   
      
  
  
        }
  
        if (down) {
         
           
           // setbgtop(tempy-my)

         
 
          //  console.log('drag mov'+(tempy-my))
           

                if(tempy-my>=10){
                       
                       if(!canmove)return
                       canmove=false
                        let movto=-window.innerHeight 
                        if(introstate==1){
                            setIntro1top(movto)
                            setIntro2top(0)
                            setintrostate(2)
                            setIntromovespeed([1,.7,1])
                        }else if(introstate==2){
                            setIntro2top(movto)
                            setIntro3top(0)
                            setintrostate(3)
                            setIntromovespeed([1,1,.7])
                            setarrowalpha(0)
                        } 

                        setTimeout(() => {
                            canmove=true
                        }, 700);
        
                }else if(tempy-my<=-10){
                    if(!canmove)return
                    canmove=false
                    let movto=window.innerHeight 
                        if(introstate==3){
                            setIntro3top(movto)
                            setIntro2top(0)
                            setintrostate(2)
                            setIntromovespeed([1,.7,1])
                            setarrowalpha(1)
                        }else if(introstate==2){
                            setIntro2top(movto)
                            setIntro1top(0)
                            setintrostate(1)
                            setIntromovespeed([.7,1,1])
                        } 

                        setTimeout(() => {
                            canmove=true
                        }, 700);
                }

               
               
        }
  
         
      },onDragEnd:({ down, movement: [mx,my]})=>{
          
         //  console.log('drag end'+my)

            if(tempy-my>12){
               // setToggle(!toggle)
               // console.log('drag up'+(tempy-my)) 
               //  let movto=-window.innerHeight   
                // setIntro1top(movto)
             
               
            }
       }
      });



    function startbtn(){
 
        console.log(111)

        setbtn1alpha(.5)
       
       // navigate('/g1',{state:{id:0,nick:''}})

       if(introstate==1){
        window.location.replace('/g1')
       }else if(introstate==2){

        window.location.replace('/g2')
       }else{
        window.location.replace('/g3')

       }

        
    }

    

    

    function testbtn(){

      
    }


    function wallpaper(){

        navigate('/wallpaper',{state:{id:0,nick:''}})
    }
 

    function mycard(){
        setbtnalpha(.5)
        //navigate('/mycard?s=1',{state:{id:0,nick:''}})

        if(introstate==1){
          //  window.location.replace('/mycard?s=1')
            navigate('/mycard?s=1',{state:{id:0,nick:''}})
        }else if(introstate==2){
          //  window.location.replace('/mycard?s=2')
          navigate('/mycard?s=2',{state:{id:0,nick:''}})
        }else if(introstate==3){
           // window.location.replace('/mycard?s=3')
           navigate('/mycard?s=3',{state:{id:0,nick:''}})
        }
       
    }
 
     return  <div  tabIndex={-1} {...bindqatwodrag()}     style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center',transition:`all 1s`,opacity:showpagealpha}}>         
                      {/*
                       <Introb  introstate={introstate} pointery={bgtop} act={active}/>
                       <Introa  introstate={introstate} pointery={bgtop} act={active}/>
                       
                    */}



                    
                   <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:Intro1top,display:'flex',justifyContent:'center',alignItems:'center',transition:`all ${Intromovespeed[0]}s`,overflow:'hidden'}}  >
                    <img 
                        src={`${hostloca}Assets/intro1.jpg`} 
                        style={{
                        width:'100%' , // Set image width to screen width
                        position: 'absolute',
                        top: bgitemtop, // Adjust this to position correctly
                        left: 0, // Center the image horizontally
                        }}
                    /> 

                    <video
                        style={{position:"absolute",display: 'block',width:videopose[0],height:videopose[1],left:videopose[2],top:videopose[3],opacity:1}}
                        playsInline
                        loop
                        muted
                     
                        
                        alt="All the devices"
                        src={hostloca+'media/c1.mp4'}
                        ref={hvideoEl}
                    />

                    </div>

                    <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:Intro2top,display:'flex',justifyContent:'center',alignItems:'center',transition:`all ${Intromovespeed[1]}s`,overflow:'hidden'}}  >
                    <img 
                        src={`${hostloca}Assets/intro2.jpg`} 
                        style={{
                        width:'100%' , // Set image width to screen width
                        position: 'absolute',
                        top: bgitemtop, // Adjust this to position correctly
                        left: 0, // Center the image horizontally
                        }}
                    />
                     <video
                        style={{position:"absolute",display: 'block',width:videopose[0],height:videopose[1],left:videopose[2],top:videopose[3],opacity:1}}
                        playsInline
                        loop
                        muted
                     
                        
                        alt="All the devices"
                        src={hostloca+'media/c2.mp4'}
                        ref={hvideoE2}
                    />

                   
                    </div>


                    <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:Intro3top,display:'flex',justifyContent:'center',alignItems:'center',transition:`all ${Intromovespeed[2]}s`,overflow:'hidden'}}  >
                    <img 
                        src={`${hostloca}Assets/intro3.jpg`} 
                        style={{
                        width:'100%' , // Set image width to screen width
                        position: 'absolute',
                        top: bgitemtop, // Adjust this to position correctly
                        left: 0, // Center the image horizontally
                        }}
                    />

                    <video
                        style={{position:"absolute",display: 'block',width:videopose[0],height:videopose[1],left:videopose[2],top:videopose[3],opacity:1}}
                        playsInline
                        loop
                        muted
                     
                        
                        alt="All the devices"
                        src={hostloca+'media/c3.mp4'}
                        ref={hvideoE3}
                    />

                    </div>

                            
        
                 <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center',transition:`all .5s`}}>         
  
                                 <div onClick={()=>startbtn()} style={{width:'40vw',height:'10vw',borderRadius:'8vw',color:'white',position:'absolute',top:'68vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',opacity:btn1alpha,transition:`all .2s`}}>开始游戏</div>

                                 <div  onClick={()=>mycard()}  style={{width:'40vw',height:'10vw',borderRadius:'8vw',color:'white',position:'absolute',top:'77vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',opacity:btnalpha,transition:`all .2s`}}>数字叙爱</div>

                 </div>


                 <img  src={hostloca+'Assets/logolarge.png'} style={{width:'50vw',position:'absolute',top:'18vh'}}/> 

                 <img   
                        src={`${hostloca}Assets/scroll.png`} 
                        style={{
                        width:'5vw' , // Set image width to screen width
                        position: 'absolute',
                        opacity:arrowalpha,
                        top: '95vh', // Adjust this to position correctly
                        transition:`all .5s`,
                        animation:'moveUpDown 2s ease-in-out infinite'
                        }}
                    />



                        <div onClick={()=>wallpaper()} className='btnnohightline'  style={{width:'7vw',height:'7vw',position:'absolute',top:'3vh',right:'6vw',opacity:1}}>

                        <img  src={hostloca+'Assets/wpbtn.png'} style={{width:'100%'}}/> 
                            
                        </div>


                  {/*
                        <audio ref={audioRef} src={hostloca+'media/sound2.mp3'} preload="auto"  />


                        <div  onClick={()=>testbtn()} style={{width:'36vw',height:'10vw',borderRadius:'8vw',backgroundColor:'white',color:'black',position:'absolute',left:'60%',top:'84vh',display:'flex',justifyContent:'center',alignItems:'center'}}>INSERT</div>
*/}
          </div>
 
  
 
 }